import React from 'react';
export const TermsOfService = () => {
  return <div className="pt-20" data-id="element-4801" data-mp="3grblm2rcoqip">
      <section className="py-16 bg-secondary/5" data-id="element-4802" data-mp="3hsp2245aaqwt">
        <div className="container mx-auto px-4" data-id="element-4803" data-mp="3hthxi8ysltzn">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-4804" data-mp="33sxhfkk9ic9u">
            Terms of Service
          </h1>
          <p className="text-center text-secondary" data-id="element-4805" data-mp="38r8qht2qgir0">Last updated: 19|08|2025</p>
        </div>
      </section>
      <section className="py-16" data-id="element-4806" data-mp="d9u4qbumvcz">
        <div className="container mx-auto px-4 max-w-4xl" data-id="element-4807" data-mp="d0bxox1pshu">
          <div className="prose prose-lg max-w-none" data-id="element-4808" data-mp="4cr15o6xc0k9">
            <p data-id="element-4809" data-mp="4fmypbev0n86">
              Welcome to The Networking Salon — a community built on connection,
              trust, and growth. By joining our events, engaging with our
              network, or using our website, you're agreeing to these terms.
              They're here to set clear expectations so everyone can have a
              safe, respectful, and valuable experience.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4810" data-mp="o3mcyw8mucic">
              1. Our Promise to You
            </h2>
            <p data-id="element-4811" data-mp="ur7eby950nju">
              We're here to create spaces — online and offline — where
              meaningful professional relationships can grow. We commit to
              providing a respectful, inclusive, and inspiring environment for
              all our members.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4812" data-mp="13q2g8y55fbhc">
              2. Your Part in the Community
            </h2>
            <p data-id="element-4813" data-mp="1dhyrlaw8wy3i">By being part of The Networking Salon, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4814" data-mp="1djt35ylmndux">
              <li data-id="element-4815" data-mp="1rgexx0q74ml4">Show up with respect, professionalism, and curiosity.</li>
              <li data-id="element-4816" data-mp="1mhvbkz7ox8s8">
                Treat fellow members with kindness, regardless of background,
                role, or opinion.
              </li>
              <li data-id="element-4817" data-mp="3t9367ohp607r">
                Use our events and platforms to build genuine connections, not
                just to pitch or sell.
              </li>
              <li data-id="element-4818" data-mp="1s753mn2rw50q">
                Keep confidential conversations private, unless you've been
                given permission to share.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4819" data-mp="224sv94530weo">
              3. Event Participation
            </h2>
            <p data-id="element-4820" data-mp="2664r3rejudvb">When you attend our events, you agree to:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4821" data-mp="267pkvet1hss4">
              <li data-id="element-4822" data-mp="2b698djna7cml">
                Follow all event guidelines and venue/virtual platform rules.
              </li>
              <li data-id="element-4823" data-mp="2g3ivutr41e7s">Respect others' time, space, and perspectives.</li>
              <li data-id="element-4824" data-mp="2kviw6nb3e94w">
                Understand that we may capture photos or videos at events, which
                may be used for promotional purposes (you can opt out in writing
                if you prefer not to be included).
              </li>
            </ul>
            <p data-id="element-4825" data-mp="2ttw3ev03aqwl">
              We reserve the right to remove anyone whose behavior disrupts the
              safe and respectful spirit of the community.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4826" data-mp="n8hyx7q5cpx3">
              4. Payments & Refunds
            </h2>
            <p data-id="element-4827" data-mp="i7amuwgz14km">Some of our events, memberships, or services require payment.</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4828" data-mp="e7tftylwbzdc">
              <li data-id="element-4829" data-mp="97xey88hwo20">
                Unless otherwise stated, tickets and fees are non-refundable,
                but we'll always try to accommodate transfers or credits if life
                gets in the way.
              </li>
              <li data-id="element-4830" data-mp="11wcrmo45mua6">
                If we cancel an event, you'll receive a full refund or credit.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4831" data-mp="x41qjhxoh2g1">
              5. Intellectual Property
            </h2>
            <p data-id="element-4832" data-mp="s4p0kobiff98">
              The Networking Salon's content, branding, and event materials
              belong to us. You're welcome to share what you've learned and
              experienced, but please don't copy or use our materials without
              permission.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4833" data-mp="14emuw64h7wi4">
              6. Liability & Expectations
            </h2>
            <ul className="list-disc pl-6 space-y-2" data-id="element-4834" data-mp="19coeqt9q7zun">
              <li data-id="element-4835" data-mp="vgkyk3vots16">
                We provide opportunities for connection, but we can't guarantee
                specific outcomes (like business deals or partnerships).
              </li>
              <li data-id="element-4836" data-mp="1o4zz5le2o7sz">
                We are not liable for any loss, damage, or injury connected to
                your participation in our events, website, or services.
              </li>
              <li data-id="element-4837" data-mp="1eex9nv65tbze">
                Participation is at your own discretion and responsibility.
              </li>
            </ul>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4838" data-mp="1jbnpqihys7kt">
              7. Updates to These Terms
            </h2>
            <p data-id="element-4839" data-mp="270q33e5kfe9i">
              We may update these terms occasionally. Any changes will be posted
              on our website, and by continuing to use our services, you agree
              to the updated version.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4840" data-mp="2h6zpznxklhlu">8. Governing Law</h2>
            <p data-id="element-4841" data-mp="2h4x2pbnsy2kt">
              These terms are governed by the laws of Nigeria, and any disputes
              will be resolved in the courts of Lagos.
            </p>
            <h2 className="text-2xl font-bold mt-8 mb-4" data-id="element-4842" data-mp="2q0culn4zy7nr">9. Contact Us</h2>
            <p data-id="element-4843" data-mp="228p8rjmldmsc">We're here for questions, clarifications, or feedback.</p>
            <p data-id="element-4844" data-mp="1y7vmeuossg1k">
              📧 Email:{' '}
              <a href="mailto:info@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-4845" data-mp="1y96x7egnuo26">
                info@thenetworkingsalon.live
              </a>
            </p>
          </div>
        </div>
      </section>
    </div>;
};